module.exports = __webpack_public_path__ + "static/img/shui4.75e9669.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/shui4.jpg
// module id = RFgt
// module chunks = 0